import React, {Component, Fragment} from "react";
import PropTypes from "prop-types";
import autobind from "autobind-decorator";
import { connect } from "react-redux";
import { Container, Row, Col,InputGroup, InputGroupAddon, Button, Input, UncontrolledTooltip, FormGroup, Label} from 'reactstrap';
import { SketchPicker as ColorPicker } from 'react-color';
import Select from 'react-select';
import makeAnimated from 'react-select/lib/animated';

import http from "../../../../services/HttpService";
import {Redirect} from "react-router";
import Route from "../../../../Routes";
import Loading from "../../../includes/Loading";

import { FilePond, registerPlugin, create } from 'react-filepond';
import 'filepond/dist/filepond.min.css';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
import FilePondPluginFilePoster from 'filepond-plugin-file-poster';
import 'filepond-plugin-file-poster/dist/filepond-plugin-file-poster.css';

import swal from "sweetalert2";
registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview, FilePondPluginFilePoster);
import i18next from 'i18next';
import { Translation } from "react-i18next";

import LayoutDashboard from "../../../../views/layout/Dashboard";
import {layout} from "../../../../../ts-helpers/decorators";

@layout(LayoutDashboard)
@(connect((state) => {
    return { };
}) as any)

export default class EditContact extends Component<any> {
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
    };

    state = {
        phone: "",
        email: "",
        address: "",
        skype: "",
        fax: "",
        facebook:"",
        linkedin:"",
        twitter:"",
        loading: true,
        updated: false
    };

    constructor(props: Map<any, any>) {
        super(props);
    }

    componentDidMount(): void {
        this.getData();
        this.props.onRef(this);
    }

    @autobind
    getData(){
        http.get(`/contacts/all`)
            .then(response => response.json())
            .then((data) => {
                this.setState({
                    loading: false,
                    phone: data.phone,
                    email: data.email,
                    address: data.address,
                    skype: data.skype,
                    fax: data.fax,
                    facebook:data.facebook,
                    linkedin:data.linkedin,
                    twitter:data.twitter
                });
            })
    }

    @autobind
    updateContact(event) {
        event.preventDefault();
        const { phone, address, email, fax, skype, facebook, linkedin, twitter } = this.state;

        http.post( '/contacts/add', {
            phone:phone,
            address:address,
            email:email,
            fax:fax,
            skype:skype,
            facebook:facebook,
            linkedin:linkedin,
            twitter:twitter
        })
            .then((response: any) => {
                if (response.ok) {
                    swal.fire('Done', 'About successfully added.', 'success')
                        .then(() => {
                            this.setState({
                                updated: true,
                            });
                        });
                } else {
                    swal.fire('Failed', 'Something went wrong.', 'error');
                }
            })
            .catch((err) => {
                swal.fire('Failed', 'Something went wrong.', 'error');
            });
    }

    @autobind
    changePhone(event) {
        const phone = event.target.value;
        this.setState({
            phone,
        });
    }

    @autobind
    changeAddress(event) {
        const address = event.target.value;
        this.setState({
            address,
        });
    }

    @autobind
    changeEmail(event) {
        const email = event.target.value;
        this.setState({
            email,
        });
    }

    @autobind
    changeSkype(event) {
        const skype = event.target.value;
        this.setState({
            skype,
        });
    }

    @autobind
    changeFax(event) {
        const fax = event.target.value;
        this.setState({
            fax,
        });
    }

    @autobind
    changeFacebook(event) {
        const facebook = event.target.value;
        this.setState({
            facebook,
        });
    }

    @autobind
    changeLinkedin(event) {
        const linkedin = event.target.value;
        this.setState({
            linkedin,
        });
    }

    @autobind
    changeTwitter(event) {
        const twitter = event.target.value;
        this.setState({
            twitter,
        });
    }

    @autobind
    changeLanguage(e) {
        const lng = e.currentTarget.dataset.lang
        this.setState({ lng: lng }, () => {
            i18next.changeLanguage(lng);
            this.props.changeLang();
        });
    }

    @autobind
    langTranslation(e){
        return <Translation>{t => t(`${e}`)}</Translation>
    }

    render() {
        const { loading, phone, skype, fax, email, address,  updated, facebook, linkedin, twitter } = this.state;
        if (updated) {
            return <Redirect to={Route.toUrl("dashboard_home")} />
        }

        return(
            <Container fluid>
                <Row>
                    <Col sm="12">
                        <h4 className="header-title m-t-0 m-b-20">Contacts!</h4>
                    </Col>
                </Row>

                {
                    loading ? <Container><Row><Col className="text-center"><Loading isLoading={loading} icon="loadDashboardInfo" /></Col></Row></Container> :
                        <Fragment>
                            <Row>
                                <Col className="dashboard_add_style_block col-sm-offset-3 col-sm-6">
                                    <form onSubmit={this.updateContact}>
                                        <Row>
                                            <Col>
                                                <FormGroup>
                                                    <Label for="phone" className="dashboard_forms_label">Phone</Label>
                                                    <Input
                                                        type="text" placeholder="Phone"
                                                        className="contact_form_input" id="phone"
                                                        value={phone} onChange={this.changePhone}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col>
                                                <FormGroup>
                                                    <Label for="email" className="dashboard_forms_label">Email</Label>
                                                    <Input
                                                        type="text" placeholder="Email"
                                                        className="contact_form_input" id="email"
                                                        value={email} onChange={this.changeEmail}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col>
                                                <FormGroup>
                                                    <Label for="address" className="dashboard_forms_label">Address</Label>
                                                    <Input
                                                        type="text" placeholder="Address"
                                                        className="contact_form_input" id="address"
                                                        value={address} onChange={this.changeAddress}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col>
                                                <FormGroup>
                                                    <Label for="skype" className="dashboard_forms_label">Skype</Label>
                                                    <Input
                                                        type="text" placeholder="Skype"
                                                        className="contact_form_input" id="skype"
                                                        value={skype} onChange={this.changeSkype}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col>
                                                <FormGroup>
                                                    <Label for="fax" className="dashboard_forms_label">Fax</Label>
                                                    <Input
                                                        type="text" placeholder="Fax"
                                                        className="contact_form_input" id="fax"
                                                        value={fax} onChange={this.changeFax}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col>
                                                <FormGroup>
                                                    <Label for="facebook" className="dashboard_forms_label">Facebook</Label>
                                                    <Input
                                                        type="text" placeholder="Facebook"
                                                        className="contact_form_input" id="facebook"
                                                        value={facebook} onChange={this.changeFacebook}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col>
                                                <FormGroup>
                                                    <Label for="linkedin" className="dashboard_forms_label">Linkedin</Label>
                                                    <Input
                                                        type="text" placeholder="Linkedin"
                                                        className="contact_form_input" id="linkedin"
                                                        value={linkedin} onChange={this.changeLinkedin}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col>
                                                <FormGroup>
                                                    <Label for="twitter" className="dashboard_forms_label">Twitter</Label>
                                                    <Input
                                                        type="text" placeholder="Twitter"
                                                        className="contact_form_input" id="twitter"
                                                        value={twitter} onChange={this.changeTwitter}
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <div className="text-center">
                                            <Button className="dashboard_add_form_button">Update</Button>
                                        </div>
                                    </form>
                                </Col>
                            </Row>
                        </Fragment>
                }

            </Container>
        );

    }
}
